(() => {
  let measDrawerComponent = null;
  let isTransitioning = false;

  function lockDrawer() {
    document.body.classList.add('measmerize-open');
  }

  function unlockDrawer() {
    document.body.classList.remove('measmerize-open');
  }

  function openMeasmerize(modal) {
    const openObserver = new MutationObserver(() => {
      const ready = document.querySelector('[data-testid="upper-header"]');
      if (!ready) return;
      openObserver.disconnect();
      requestAnimationFrame(() => modal.classList.add('is-open'));
    });
    openObserver.observe(modal, { childList: true, subtree: true });
    if (document.querySelector('[data-testid="upper-header"]')) {
      requestAnimationFrame(() => modal.classList.add('is-open'));
    }
  }

  // Additional button — no handoff
  document.addEventListener('click', (e) => {
    if (!e.target.closest('.measmerize-additional-button')) return;

    const measModal = document.getElementById('measmerize-modal');
    if (!measModal) return;

    measDrawerComponent = null;
    lockDrawer();
    openMeasmerize(measModal);
  }, true);

  // Main listener
  document.addEventListener(
    'click',
    (e) => {
      const measModal = document.getElementById('measmerize-modal');

      // =====================================================
      // CLOSE MEASMERIZE — X button only
      // =====================================================
      if (measModal) {
        const isClose = !!e.target.closest('[data-testid="close-button"]');

        if (isClose && !e.target.dataset.measAnimated) {
          e.stopImmediatePropagation();
          e.preventDefault();

          if (isTransitioning) return;
          isTransitioning = true;

          measModal.classList.remove('is-open');
          measModal.classList.add('is-closing');

          const target = e.target;

          // measmerize finishes closing
          setTimeout(() => {
            measModal.classList.remove('is-closing');
            unlockDrawer();
            target.dataset.measAnimated = 'true';
            target.dispatchEvent(
              new MouseEvent('click', { bubbles: true, cancelable: true })
            );
            setTimeout(() => delete target.dataset.measAnimated, 100);
          }, 420);

          // drawer starts opening with overlap — matches cart handoff
          if (measDrawerComponent) {
            const componentToReopen = measDrawerComponent;
            measDrawerComponent = null;
            setTimeout(() => {
              isTransitioning = false;
              if (!componentToReopen.refs?.dialog?.open) {
                componentToReopen.showDialog();
              }
            }, 480);
          } else {
            measDrawerComponent = null;
            setTimeout(() => {
              isTransitioning = false;
            }, 480);
          }

          return;
        }
      }

      // =====================================================
      // OPEN MEASMERIZE FROM DRAWER
      // =====================================================
      if (!e.target.closest('#measmerize-button')) return;

      if (isTransitioning) return;

      const openDrawer = document.querySelector(
        'dialog.maison-product-drawer[open]'
      );
      if (!openDrawer) return;

      if (openDrawer.classList.contains('dialog-closing')) return;

      const dialogComponent = openDrawer.closest('dialog-component');
      if (!dialogComponent) return;

      isTransitioning = true;
      measDrawerComponent = dialogComponent;

      // mirror cart handoff exactly
      openDrawer.classList.add('dialog-closing');

      requestAnimationFrame(() => {

        // old drawer finishes leaving
        setTimeout(async () => {
          await dialogComponent.closeDialog();
        }, 420);

        // measmerize starts opening with overlap
        setTimeout(() => {
          isTransitioning = false;
          lockDrawer();
          const modal = document.getElementById('measmerize-modal');
          if (!modal) return;
          openMeasmerize(modal);
        }, 480);

      });
    },
    true
  );
})();